import { z } from 'zod';
import { csv, oneOf, str } from '../../navigation/searchParams';

/** The search box, the expanded integration types, and the profile editor. */
export const integrationsSearch = z.object({
  q: str,
  expanded: csv,
  modal: oneOf(['create-integration', 'edit-integration']),
  type: str,
  id: str,
  mtab: str,
});
